import apiClient from '@/api/apiClient'

export const getProfile = () => apiClient.get('api/v1/profile')

export const updateProfile = payload =>
  apiClient.patch('api/v1/profile', payload)
